import Styles from './Message.module.scss'
import { MessageProps } from './Types'
import { useRetryMessage } from 'hooks/queries/chat/useRetryMessage'
import { Button } from 'blaze-ui/Button'

export const ErrorMessage = ({ message }: MessageProps) => {
  const { mutate: retryMessage, isLoading } = useRetryMessage()

  const handleRetry = () => {
    retryMessage({ threadId: message.thread_id, id: message.id })
  }

  return (
    <div className={Styles.message} data-testid="error-message">
      There was an error when trying to complete your request. Click the retry button or write another message to try
      again.
      <Button variant="tertiary" onPress={handleRetry} isDisabled={isLoading}>
        Retry
      </Button>
    </div>
  )
}
